export default "__VITE_ASSET__CNa7BOpg__"